jQuery(document).ready(function () {

    jQuery('#abonnement_countries').on('change', function() {

        jQuery('#prieDisplay-Abo').html(jQuery(this).val());
    });

    jQuery('#abonnement_time').on('change', function() {
/*
        var price = '-';
        console.log(jQuery(this).val());
        switch(jQuery(this).val()) {

        }*/
        jQuery('#prieDisplay-AboPrice').html(jQuery(this).val());
    });

    jQuery('#your-company').on('change', function() {

        if(jQuery(this).val().length > 0) {
            jQuery('#order-details').html('Ein Abonnement kann von einem Unternehmer bis zu einem Monat vor Ende des Bezugszeitraums in Textform bei Unika gekündigt werden. Wird das Abonnement nicht rechtzeitig gekündigt, verlängert sich das Abonnement jeweils um die Dauer des Erstbezugszeitraumes.');
        } else {
            jQuery('#order-details').html('Ein Abonnement kann von einem Verbraucher bis zu einem Monat vor Ende des Erstbezugszeitraumes in Textform bei Unika gekündigt werden. Wird das Abonnement nicht rechtzeitig gekündigt, verlängert sich dieses auf unbestimmte Zeit, wobei dem anderen Vertragsteil das Recht eingeräumt wird, das verlängerte Vertragsverhältnis jederzeit mit einer Frist von einem Monat zu kündigen.');
        }
    });

    jQuery('#your-company').on('input', function() {

        if(jQuery(this).val().length !== 0) {
            jQuery('#hide-company').fadeOut();
        } else {

            jQuery('#hide-company').fadeIn();
        }
    });

});

